@if (patient) {
  <div class="row m-0">
    <div class="col-md-4">
      <app-patient-about [editLink]="'./edit'" [patient]="patient"></app-patient-about>
    </div>
    <div class="col-md-8 my-3">
      <span class="shadow-sm w-auto p-2 rounded">{{ 'family' | transloco }}</span>

      <div class="card shadow-sm rounded border-0 mt-3">
        <div class="card-body">
          <!-- <router-outlet /> -->
          <app-family></app-family>
        </div>
      </div>
    </div>
  </div>
}
